import { useMutation } from '@tanstack/react-query';

import { SendLixiRequest } from '../../../../../types';
import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { postApplicationRunPpsrIntegration } from '../../requests/postApplicationRunPpsrIntegration';

export const useApplicationRunPpsrIntegration = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: runPpsrIntegration, ...rest } = useMutation({
    mutationFn: ({ uuid, data }: { uuid: string; data: SendLixiRequest }) =>
      postApplicationRunPpsrIntegration(
        constructPost,
        uuid,
        definitionName,
        data,
      ),
    onSuccess: () => handleSuccess('Report queued for processing.'),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'PPSR integration failed.')),
  });

  return { runPpsrIntegration, ...rest };
};
